module.exports = __webpack_public_path__ + "static/media/register_background.74a071d8.jpg";